import Image from 'next/image'
import { Avatar, AvatarFallback, AvatarImage } from '@eversports/klimt-primitives/Avatar'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@eversports/klimt-primitives/DropdownMenu'
import { useTranslations } from 'next-intl'

import SeoLink from '../../../../components/seoLink'

import { User, UserItem } from './UserMenu.types'
import getUserInitials from './helpers/get-user-initials'

interface Props {
  user: User
  menuItems: Array<UserItem>
}

const DesktopUserMenu = ({ user, menuItems }: Props) => {
  const t = useTranslations('header')
  const userInitials = getUserInitials(user)
  return (
    <div className="hidden items-center gap-1 md:flex">
      <p className="text-base">
        {t('greeting')}, <b>{user.firstName}</b>
      </p>
      <DropdownMenu modal={true}>
        <DropdownMenuTrigger>
          <Avatar role="dialog" aria-label={t('aria-label-user-menu')}>
            <AvatarImage src={user.profilePicture?.xSmall} />
            <AvatarFallback>{userInitials}</AvatarFallback>
          </Avatar>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          {menuItems
            .filter((item) => !item.isHidden)
            .map((item, index) => (
              <DropdownMenuItem
                key={index}
                className="first-of-type:border-b first-of-type:border-b-slate-200 last-of-type:border-t last-of-type:border-b-slate-200"
              >
                <SeoLink
                  type="hidden"
                  encodedTo={btoa(item.to)}
                  className="flex w-full items-center gap-1 p-1"
                  ariaLabel={t(item.translationKey)}
                >
                  <Image src={item.icon} width={16} alt="" /> {/* alt text marked as redundant  */}
                  {t(item.translationKey)}
                </SeoLink>
              </DropdownMenuItem>
            ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}
export default DesktopUserMenu
